import React from 'react';
import { bool, func } from 'prop-types';

// Components
import { Button, MenuItem, Toolbar } from '@mui/material';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';

// Styles
import { useTheme } from '@mui/material/styles';
import { buttonStyles, toolBarStyles, toolbarTabsStyles } from './MobileToolbar.styles';

const MobileToolbar = ({
  affiliateTableChange,
  setDialogOpen,
  setLegendDrawerOpen,
  userTableChange,
}) => {
  const theme = useTheme();
  const enabled = affiliateTableChange || userTableChange;

  return (
    <Toolbar disableGutters sx={{ ...toolBarStyles(theme) }}>
      <Button
        color="primary"
        disabled={!enabled}
        onClick={() => setDialogOpen(true)}
        sx={buttonStyles}
      >
        Save
      </Button>
      <MenuItem onClick={() => setLegendDrawerOpen(true)} sx={{ ...toolbarTabsStyles(theme) }}>
        Legend
        <ChevronRightRoundedIcon />
      </MenuItem>
    </Toolbar>
  );
};

MobileToolbar.propTypes = {
  affiliateTableChange: bool.isRequired,
  setDialogOpen: func.isRequired,
  setLegendDrawerOpen: func.isRequired,
  userTableChange: bool.isRequired,
};

export default MobileToolbar;
